import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";

const StyleTab = ({ handleLayoutChange, selectedLayout,updateSocialMediaIconsTabData,socialMediaIconsTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [iconColor, setIconColor] = useState(socialMediaIconsTabData.icon_color);
    const [backgroundColor, setBackgroundColor] = useState(socialMediaIconsTabData.background_color);
    const [iconColorOnHover, setIconColorOnHover] = useState(socialMediaIconsTabData.icon_color_on_hover);
    const [backgroundColorOnHover, setBackgroundColorOnHover] = useState(socialMediaIconsTabData.background_color_on_hover);
    const [icionShapeType, setIcionShapeType] = useState(socialMediaIconsTabData.icons_shape_type);
    const [animationType, setAnimationType] = useState(socialMediaIconsTabData.animation_type);
    const [animationTypeDropdownOpen, setAnimationTypeDropdownOpen] = useState(false);
    const [opacitySize, setOpacitySize] = useState(socialMediaIconsTabData.opacity_size);
    const [opacityOnHoverSize, setOpacityOnHoverSize] = useState(socialMediaIconsTabData.opacity_on_hover_size);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(socialMediaIconsTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(socialMediaIconsTabData.custom_js);

    // Handlers Opacity Size Change
    const handleOpacitySizeChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        const MIN_SIZE = 0;
        const MAX_SIZE = 100;
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWithPx = `${clampedValue}%`;
        setOpacitySize(valueWithPx); 
        updateSocialMediaIconsTabData("opacity_size", valueWithPx);
    };

    // Handlers Opacity On Hover Size Change
    const handleOpacityOnHoverSizeChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        const MIN_SIZE = 0;
        const MAX_SIZE = 100;
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWithPx = `${clampedValue}%`;
        setOpacityOnHoverSize(valueWithPx); 
        updateSocialMediaIconsTabData("opacity_on_hover_size", valueWithPx);
    };


    // Handle Icon Color Change
    const handleIconColorChange = (event) => {
        setIconColor(event.target.value);
        updateSocialMediaIconsTabData("icon_color", event.target.value);
    };

    // Handle Background Color Change
    const handleBackgroundColorChange = (event) => {
        setBackgroundColor(event.target.value);
        updateSocialMediaIconsTabData("background_color", event.target.value);
    };

    // Handle Icon Color On Hover Color change
    const handleIconColorOnHoverChange = (event) => {
        setIconColorOnHover(event.target.value);
        updateSocialMediaIconsTabData("icon_color_on_hover", event.target.value);
    };

    // Handle Background Color On Hover change
    const handleBackgroundColorOnHoverChange = (event) => {
        setBackgroundColorOnHover(event.target.value);
        updateSocialMediaIconsTabData("background_color_on_hover", event.target.value);
    };


    // Handle Icion Shape Type change
    const handleIcionShapeTypeChange = (event) => {
        setIcionShapeType(event.target.value);
        updateSocialMediaIconsTabData("icons_shape_type", event.target.value);
    };

    // Handlers Animation Type Change
    const handleAnimationTypeChange = (type) => {
        setAnimationType(type);
        updateSocialMediaIconsTabData("animation_type", type);
        setAnimationTypeDropdownOpen(false);
    };
    
    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateSocialMediaIconsTabData("custom_css", code);
    };
    
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateSocialMediaIconsTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };
    
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("colors")}>Colors<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("icons_shape")}>Icons Shape<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("animation")}>Animation<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("opacity")}>Opacity<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "colors" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Colors</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Icon Color</p>
                                <div className="left-cnater-right-button mb-0">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="icon_color_type" className="card-input-element d-none" value="native" onChange={handleIconColorChange} checked={iconColor === "native"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Native</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="icon_color_type" className="card-input-element d-none" value="black" onChange={handleIconColorChange} checked={iconColor === "black"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Black</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="icon_color_type" className="card-input-element d-none" value="white" onChange={handleIconColorChange} checked={iconColor === "white"} />
                                        <div className="card card-body">
                                            <div className="content_sub">White</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Background Color</p>
                                <div className="left-cnater-right-button mb-0">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="background_color_type" className="card-input-element d-none" value="native" onChange={handleBackgroundColorChange} checked={backgroundColor === "native"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Native</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="background_color_type" className="card-input-element d-none" value="black" onChange={handleBackgroundColorChange} checked={backgroundColor === "black"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Black</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="background_color_type" className="card-input-element d-none" value="white" onChange={handleBackgroundColorChange} checked={backgroundColor === "white"} />
                                        <div className="card card-body">
                                            <div className="content_sub">White</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Icon Color on Hover</p>
                                <div className="left-cnater-right-button mb-0">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="icon_on_hover_color_type" className="card-input-element d-none" value="native" onChange={handleIconColorOnHoverChange} checked={iconColorOnHover === "native"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Native</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="icon_on_hover_color_type" className="card-input-element d-none" value="black" onChange={handleIconColorOnHoverChange} checked={iconColorOnHover === "black"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Black</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="icon_on_hover_color_type" className="card-input-element d-none" value="white" onChange={handleIconColorOnHoverChange} checked={iconColorOnHover === "white"} />
                                        <div className="card card-body">
                                            <div className="content_sub">White</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Background Color on Hover</p>
                                <div className="left-cnater-right-button mb-0">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="background_color_on_hover_color_type" className="card-input-element d-none" value="native" onChange={handleBackgroundColorOnHoverChange} checked={backgroundColorOnHover === "native"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Native</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="background_color_on_hover_color_type" className="card-input-element d-none" value="black" onChange={handleBackgroundColorOnHoverChange} checked={backgroundColorOnHover === "black"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Black</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="background_color_on_hover_color_type" className="card-input-element d-none" value="white" onChange={handleBackgroundColorOnHoverChange} checked={backgroundColorOnHover === "white"} />
                                        <div className="card card-body">
                                            <div className="content_sub">White</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "icons_shape" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Icons Shape</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <div className="left-cnater-right-button mb-0">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="icion_shape_type" className="card-input-element d-none" value="circle" onChange={handleIcionShapeTypeChange} checked={icionShapeType === "circle"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Circle</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="icion_shape_type" className="card-input-element d-none" value="rounded" onChange={handleIcionShapeTypeChange} checked={icionShapeType === "rounded"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Rounded</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="icion_shape_type" className="card-input-element d-none" value="square" onChange={handleIcionShapeTypeChange} checked={icionShapeType === "square"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Square</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "animation" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Animation</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Animation</span>
                                <div className="color-pikr-box" onClick={() => setAnimationTypeDropdownOpen(!animationTypeDropdownOpen)}>
                                    <em>{animationType}</em>
                                    {animationTypeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["None","Bounce"].map((type) => (
                                                <li key={type} onClick={() => handleAnimationTypeChange(type)}>
                                                    {type}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "opacity" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Opacity</span>
                        <div className="side-baar-box-header mb-3">
                            <div className="box-header-row">
                                <span>Opacity</span>
                                <em>{parseInt(opacitySize)}%</em>
                                <div className="slider-container">
                                    <input
                                        type="range"
                                        min="0"
                                        max="100"
                                        value={parseInt(opacitySize)}
                                        onChange={handleOpacitySizeChange}
                                    />
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Opacity On Hover</span>
                                <em>{parseInt(opacityOnHoverSize)}%</em>
                                <div className="slider-container">
                                    <input
                                        type="range"
                                        min="0"
                                        max="100"
                                        value={parseInt(opacityOnHoverSize)}
                                        onChange={handleOpacityOnHoverSizeChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default StyleTab;